import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Alert, Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { Skeleton } from 'primereact/skeleton'
import { BI_AUT001Context } from './context'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import GridFooter from './Grid/GridFooter'
import {
  fnGetValueByKey,
  fnGroupRecursiveData,
  fnReplaceParamKeyWithFilteredValue
} from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext'

/**
 * Template automatizado
 * @description Esse template está mapeado para receber todos os dados de uma Procedure, e
 * se auto-rederizar.
 */

const BI_AUT001 = () => {  
  console.log('🤖 %cTransação dinâmica [BI_AUT001]', 'color:green')  
  const { transactionData } = useContext(AuthProtectedContext)
  const data = transactionData || null  
  
  const { userProfile, isModalPage, isIframePage } = useSelector(state => ({
    userProfile: state.login.user,
    isModalPage: state.Layout.isModalPage,
    isIframePage: state.Layout.isIframePage
  }))

  const [isLoading, setisLoading] = useState(false)

  const [gridComponents, setgridComponents] = useState({
    HEAD: [],
    HEADER: [],
    BODY: [],
    FOOTER: []
  })

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState('')
  const [filteredData, setFilteredData] = useState([])

  useEffect(
    useCallback(() => {
      if (data) {
        let recursiveTree = fnGroupRecursiveData(data)
        recursiveTree = { ...recursiveTree }
        console.log('recursiveTree', recursiveTree)

        setgridComponents(state => ({
          ...state,
          HEAD: [recursiveTree[0]?.HEAD],
          HEADER: [recursiveTree[1]?.HEADER],
          BODY: [recursiveTree[2]?.BODY],
          FOOTER: [recursiveTree[3]?.FOOTER]
        }))
      }
    }, [data]),
    []
  ) 
 
  if (!data)
    return (
      <div className="page-content">
        <Alert color="danger">
          Esta é uma transação automática e configurável. Seu carregamento
          depende de uma rotina.
        </Alert>
      </div>
    )

  return (
    <React.Fragment>
      <BI_AUT001Context.Provider
        value={{
          isLoading,
          userProfile,
          gridComponents,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          fnReplaceParamKeyWithFilteredValue,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData
        }}
      >
        <div style={{ padding: isModalPage && '0px', overflow: (isModalPage || isIframePage) && 'hidden'}}  className={`page-content ${isIframePage && 'is-iframe-content'}`}>
          <Container fluid={true} className="dataTable-custom-primary">
            {gridComponents.HEADER.length ? (
              <GridHeader context={BI_AUT001Context} />
            ) : (
              <Skeleton className="mb-3 mt-3" width="100%" height="5rem"></Skeleton>
            )}

            {gridComponents.BODY.length ? (
              <GridBody />
            ) : (
              <Skeleton className="mb-3" width="100%" height="50vh"></Skeleton>
            )}

          </Container>          
        </div>

        {!isModalPage && <>
          {gridComponents.FOOTER.length ? (
            <GridFooter />
          ) : (
            <Skeleton className="mb-3" width="100%" height="5rem"></Skeleton>
          )}
        </>}
        
      </BI_AUT001Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(BI_AUT001)
